import React, { useEffect ,useState} from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createTourismPolicys, getTourismPolicy, resetState, updateTourismPolicy } from "../features/TourismPolicySclice";
import { toast } from "react-toastify";
import CustomInput from "../components/CustomInput";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
let schema = yup.object().shape({
  name: yup.string().required("Policy Name is Required"),
  policyDetails: yup.string().required("Policy Details is Required"),
 
});

const AddTourismPolicy = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];
  const NewsState = useSelector((state) => state.tourismPolicy);
  const { isSuccess, isError, isLoading, createdTourismPolicy, associationName, associationpolicyDetails, updatedTourismPolicy } = NewsState;
  

  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getTourismPolicy(getNewsId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsId]);

  useEffect(() => {
    dispatch(resetState());
   
  }, []);

  useEffect(() => {
    if (isSuccess && createdTourismPolicy) {
      navigate("/ppp/Tourism-Policy-list");
      toast.success("Tourism Policy Added Successfully!");
      dispatch(resetState());
    }
    if (isSuccess && updatedTourismPolicy) {
      navigate("/ppp/Tourism-Policy-list");
      toast.success("Tourism Policy Updated Successfully!");
      
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      
      name: associationName || "",
      policyDetails: associationpolicyDetails || ""
      
      
    },
    validationSchema: schema,
    onSubmit: (values) => {
      
      const formData = new FormData();
      
      formData.append("policyName", values.name);
      formData.append("policyDetails", values.policyDetails);
      
      if (getNewsId !== undefined) {
        const data = { id: getNewsId, NewsData: formData };
        dispatch(updateTourismPolicy(data));
        dispatch(resetState());
      } else {
        dispatch(createTourismPolicys(formData));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  return (
    <div>
      <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} Tourism Policy</h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter TourismPolicy Name"
              name="name"
              onChng={formik.handleChange("name")}
              onBlr={formik.handleBlur("name")}
              val={formik.values.name}
            />
            <div className="error">{formik.touched.name && formik.errors.name}</div>
          </div>
          
          <ReactQuill
            theme="snow"
            className="mt-3"
            name="policyDetails"
            modules={modules}
            onChange={formik.handleChange("policyDetails")}
            value={formik.values.policyDetails}
          />
          <div className="error">{formik.touched.policyDetails && formik.errors.policyDetails}</div>

          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getNewsId !== undefined ? "Edit" : "Add"} Tourism Policy
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddTourismPolicy;